import { Updater } from 'use-immer'
import Checkbox from '../../../../components/Checkbox'
import { TCheckboxName, TCheckboxesData, TMyQuestions } from './data'
import { ButtonGroup, CheckboxesContainer } from './styles'

interface IProps {
  checkboxes: TCheckboxesData
  onCheckboxChange: (checkboxName: TCheckboxName) => (value: boolean) => void

  myQuestions: TMyQuestions
  setMyQuestions: Updater<TMyQuestions>
}

const Checkboxes = (props: IProps) => {
  return (
    <CheckboxesContainer className="hide-in-simple-mode">
      <div className="group hide-in-desktop">
        <p className="title">Exibir questões</p>
        <div className="wrapper">
          <div className="checkbox-group">
            <Checkbox
              className="checkbox"
              value={props.checkboxes.canceled}
              onChange={props.onCheckboxChange('canceled')}
            >
              Anuladas
            </Checkbox>
            <Checkbox
              className="checkbox"
              value={props.checkboxes.commented}
              onChange={props.onCheckboxChange('commented')}
            >
              Comentadas
            </Checkbox>
          </div>
        </div>
      </div>

      <div className="group">
        <p className="title">Minhas questões:</p>
        <div className="wrapper">
          <ButtonGroup>
            <button
              data-active={props.myQuestions.correct}
              onClick={() =>
                props.setMyQuestions((draft) => {
                  draft.correct = !draft.correct
                  draft.unanswered = false
                })
              }
            >
              Corretas
            </button>
            <button
              data-active={props.myQuestions.wrong}
              onClick={() =>
                props.setMyQuestions((draft) => {
                  draft.wrong = !draft.wrong
                  draft.unanswered = false
                })
              }
            >
              Erradas
            </button>
            <button
              data-active={props.myQuestions.unanswered}
              onClick={() =>
                props.setMyQuestions((draft) => {
                  draft.unanswered = !draft.unanswered
                  draft.correct = false
                  draft.wrong = false
                })
              }
            >
              Não respondidas
            </button>
          </ButtonGroup>
        </div>
      </div>
    </CheckboxesContainer>
  )
}

export default Checkboxes
